/**
 * @file 请求标识
 * @author wangzhuang
 */

// 安全社区首页
export const GET_CMSAPI_INDEXDATA = 'GET_CMSAPI_INDEXDATA';

// 标签页面
export const GET_CMSAPI_TAGARTICLEDATA = 'GET_CMSAPI_TAGARTICLEDATA';

// 单篇文章数据
export const GET_CMSAPI_GETARTICLEDATA = 'GET_CMSAPI_GETARTICLEDATA';

// 文章点赞
export const GET_CMSAPI_ZAN = 'GET_CMSAPI_ZAN';

export const GET_CMSAPI_PUBLISH = 'GET_CMSAPI_PUBLISH';

// 文章搜索
export const GET_CMSAPI_SEARCHARTICLE = 'GET_CMSAPI_SEARCHARTICLE';

// 官网首页
export const GET_CMSAPI_GETHOMEPAGE = 'GET_CMSAPI_GETHOMEPAGE';

// 判断是否登录
export const GET_USER_LOGINSTATE = 'GET_USER_LOGINSTATE';

// 安全社区文章列表
export const GET_ARTICLE_LIST = 'GET_ARTICLE_LIST';

// 导航列表
export const GET_NAVIGATION_LIST = 'GET_NAVIGATION_LIST';

// 产品详情
export const GET_PAGES_DATABYID = 'GET_PAGES_DATABYID';

// 产品价格
export const GET_SERVICE_INTRODUCE = 'GET_SERVICE_INTRODUCE';

// 更新产品页面的id
export const POST_PRODUCT_ID = 'POST_PRODUCT_ID';

// 申请试用获取业务、时间列表
export const GET_USER_APPLY_DATA = 'GET_USER_APPLY_DATA';

// 申请试用页面提交
export const GET_CMSAPI_USERAPPLY = 'GET_CMSAPI_USERAPPLY';

// 帮助支持导航列表
export const GET_HELPAPI_INDEX = 'GET_HELPAPI_INDEX';

// 帮助指南文章页
export const GET_HELPAPI_GETTEXT = 'GET_HELPAPI_GETTEXT';

// 获取落地页当前的id父级导航索引
export const GET_NAVLIST_INDEX = 'GET_NAVLIST_INDEX';

// 获取产品列表
export const GET_CMSAPI_PRODUCT_LIST = 'GET_CMSAPI_PRODUCT_LIST';

// 产品详情首页
export const GET_CMSAPI_PRODUCT_DETAIL_INDEX = 'GET_CMSAPI_PRODUCT_DETAIL_INDEX';

// 产品详情列表第一页
export const GET_CMSAPI_PRODUCT_DETAIL_LIST = 'GET_CMSAPI_PRODUCT_DETAIL_LIST';

// 产品详情列表分页
export const GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST = 'GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST';

// 获取黄页数据列表接口
export const GET_NUMBER_COMMON_LIST = 'GET_NUMBER_COMMON_LIST';

// 获取黄页数据详情接口
export const GET_NUMBER_COMMON_INFO = 'GET_NUMBER_COMMON_INFO';

// 号码模糊查询接口
export const GET_NUMBER_SEARCH_RESULT = 'GET_NUMBER_SEARCH_RESULT';

// 号码举报接口
export const POST_NUMBER_REPORT = 'POST_NUMBER_REPORT';

// 获取号码举报审核列表
export const GET_ALREADY_PHONE_LIST = 'GET_ALREADY_PHONE_LIST';

// 获取组织信息
export const GET_INSTANCE_INFO = 'GET_INSTANCE_INFO';

// 聚合页-获取产品列表
export const GET_ACTIVITY_GET_SERVICE = 'GET_ACTIVITY_GET_SERVICE';

// 聚合页-获取组织ID
export const GET_INSTANCE_GETINSTANCE = 'GET_INSTANCE_GETINSTANCE';

// 聚合页-购买服务
export const GET_APIMEAL_PAY = 'GET_APIMEAL_PAY';

// VDC 文件查询
export const GET_VDC_REPORT = 'GET_VDC_REPORT';

// VDC 文件查询
export const GET_URL_UPLOAD = 'GET_URL_UPLOAD';

// 抽奖活动服务列表
export const GET_GET_NEW_SERVICE = 'GET_GET_NEW_SERVICE';

// 漏洞扫描套餐活动列表
export const GET_SCAN_SERVERVICE = 'GET_SCAN_SERVERVICE';

// 史宾格申请表单
export const AUTH_PRIVACY_COMPANY_V2 = 'AUTH_PRIVACY_COMPANY_V2';

// 史宾格申请表单
export const GET_REPORT_DATA = 'GET_REPORT_DATA';

// 深度检测查询
export const FETCH_CHACK_AI_IMAGE = 'FETCH_CHACK_AI_IMAGE';
// ai安防
export const FETCH_CHACK_AI_INSDUSTRY = 'FETCH_CHACK_AI_INSDUSTRY';

// 漏洞查询
export const GET_VUL_HOMEPAGE = 'GET_VUL_HOMEPAGE';

// 漏洞搜索
export const GET_VUL_SEARCH = 'GET_VUL_SEARCH';

// 漏洞详情
export const GET_VUL_DETAIL = 'GET_VUL_DETAIL';

// 鲁棒性排行榜
export const GET_LEADER_BOARD = 'GET_LEADER_BOARD';



// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js